export const SearchFieldType: Record<string, any> = {
    "next_installment":'month',
    "next_due_installments": 'month',
    "date_of_payment": 'date',
    "fund_date": 'date',
    "evaluation_date": 'month',
    "attendenceDate": 'date',
}
